const contentType = "RebrandProgram";
export default ({ header }, { storyList = [] }) => {
	return {
		header,
		programList: storyList?.[contentType] || [],
		contentType,
	};
};
